var React = require('react');

function StarsInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M8 8.42437C12.3942 7.87654 15.877 4.39398 16.4251 0H16.5755C17.1235 4.3938 20.6061 7.87625 25 8.4243V8.57469C20.6057 9.12279 17.123 12.6057 16.5753 17H16.4252C15.8775 12.6055 12.3945 9.1225 8 8.57463L8 8.42437Z","fill":"white","key":0}),React.createElement("path",{"d":"M1 19.46C3.32633 19.1699 5.17018 17.3262 5.46034 15H5.53995C5.8301 17.3261 7.6738 19.1698 10 19.4599V19.5395C7.67363 19.8297 5.82982 21.6736 5.53989 24H5.4604C5.17046 21.6735 3.32651 19.8296 1 19.5395L1 19.46Z","fill":"white","key":1})]);
}

StarsInline.defaultProps = {"width":"26","height":"24","viewBox":"0 0 26 24","fill":"none"};

module.exports = StarsInline;

StarsInline.default = StarsInline;
